"use client";
import React, { useState } from "react";
import * as _Builtin from "./_Builtin";
import * as _interactions from "./interactions";
import { ErrorHandler } from "./ErrorHandler";
import * as _utils from "./utils";
import _styles from "./Dialer.module.css";
import { STATUS } from "../common/const";
import { Loader } from "../component/common/Loader";
import { callManager } from "../App";

// const _interactionsData = JSON.parse(
//   '{"events":{"e-877":{"id":"e-877","name":"","animationType":"preset","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-8","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-878"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"d105f99f-87d8-00b1-ab20-2f34de1ff959","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"d105f99f-87d8-00b1-ab20-2f34de1ff959","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1721147750720},"e-887":{"id":"e-887","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-58","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-888"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"d105f99f-87d8-00b1-ab20-2f34de1ff97c","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"d105f99f-87d8-00b1-ab20-2f34de1ff97c","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1721204693721},"e-985":{"id":"e-985","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-65","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-986"}},"mediaQueries":["main","medium","small","tiny"],"target":{"appliesTo":"ELEMENT","styleBlockIds":[],"id":"d105f99f-87d8-00b1-ab20-2f34de1ff94a"},"targets":[],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1721752075406},"e-986":{"id":"e-986","name":"","animationType":"custom","eventTypeId":"MOUSE_SECOND_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-66","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-985"}},"mediaQueries":["main","medium","small","tiny"],"target":{"appliesTo":"ELEMENT","styleBlockIds":[],"id":"d105f99f-87d8-00b1-ab20-2f34de1ff94a"},"targets":[],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1721752075407}},"actionLists":{"a-8":{"id":"a-8","title":"dialer/contacts to oncall","actionItemGroups":[{"actionItems":[{"id":"a-8-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"PARENT","selector":".phone_dialer","selectorGuids":["4c1e0262-5998-4bad-61c6-e320c7a90f01"]},"value":"none"}},{"id":"a-8-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{},"value":"none"}},{"id":"a-8-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{},"value":"flex"}},{"id":"a-8-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".history","selectorGuids":["69e20447-9e8a-4c7a-b9bf-d8787134d1b8"]},"value":"none"}},{"id":"a-8-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".phone_oncall","selectorGuids":["9c08117b-d5fb-d78c-1ca7-a4bbfbda9359"]},"value":"flex"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1701700810673},"a-58":{"id":"a-58","title":"end call","actionItemGroups":[{"actionItems":[{"id":"a-58-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"PARENT","selector":".phone_oncall","selectorGuids":["9c08117b-d5fb-d78c-1ca7-a4bbfbda9359"]},"value":"none"}},{"id":"a-58-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".phone_dialer","selectorGuids":["4c1e0262-5998-4bad-61c6-e320c7a90f01"]},"value":"flex"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1721204696961},"a-65":{"id":"a-65","title":"error handler [show]","actionItemGroups":[{"actionItems":[{"id":"a-65-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"value":"flex","target":{"selector":".error-handler","selectorGuids":["998741c8-366b-f1e1-d887-284c5a41310e"]}}}]}],"createdOn":1721752078053,"useFirstGroupAsInitialState":false},"a-66":{"id":"a-66","title":"error handler [hide]","actionItemGroups":[{"actionItems":[{"id":"a-66-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"value":"none","target":{"selector":".error-handler","selectorGuids":["998741c8-366b-f1e1-d887-284c5a41310e"]}}}]}],"createdOn":1721752125196,"useFirstGroupAsInitialState":false}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}'
// );

export function Dialer({ as: _Component = _Builtin.Block, dialerHandler = () => { }, callStatus = "",
  handleHangUp = () => { }, incomingCallInfo = {}, dialerLoading = false, callErrorMsg = "", openModalKeypad = () => { },
  onSetCurrentNumber = (callback) => { },
}) {
  // _interactions.useInteractions(_interactionsData, _styles);
  const [currentNumber, setCurrentNumber] = useState('');
  const maxLength = 15;

  const addDigit = (digit) => {
    if (currentNumber.length < maxLength) {
      setCurrentNumber(prevNumber => prevNumber + digit);
    }
  };

  const erase = () => {
    setCurrentNumber(prevNumber => prevNumber.slice(0, -1));
  };

  callManager.on("assignNumber", (number) => {
    setCurrentNumber(number);
  });


  return (
    <div className={"phonediv"} tag="div">
      {dialerLoading && <Loader height="43vh" />}
      <div className={"phone_dialer"} tag="div"
        style={{ display: dialerLoading || callStatus === STATUS.ONCALL ? "none" : "flex" }}
      >
        <_Builtin.Block
          className={_utils.cx(_styles, "dialer_maincontainer")}
          tag="div"
        >
          <_Builtin.Block
            className={_utils.cx(_styles, "dialer_fieldblock-container")}
            tag="div"
          >
            <_Builtin.Block
              className={_utils.cx(_styles, "dialerfield_container")}
              tag="div"
            >
              <_Builtin.FormTextInput
                className={_utils.cx(_styles, "dialerfield")}
                name="name-3"
                maxLength={256}
                data-name="Name 3"
                placeholder="(505)-xxx-xxxxx"
                disabled={false}
                type="text"
                defaultValue={currentNumber}
                onChange={(e) => setCurrentNumber(e.target.value)}
                required={false}
                autoFocus={false}
                id="name-3"
              />
            </_Builtin.Block>
          </_Builtin.Block>
          {callStatus === STATUS.ERROR && <ErrorHandler textError={callErrorMsg ? callErrorMsg : "Invalid phone number. Please check and try again."} />}
          <_Builtin.Block
            className={_utils.cx(_styles, "dialer_main")}
            tag="div"
          >
            <_Builtin.Block
              className={_utils.cx(_styles, "keypadcontainer")}
              tag="div"
              onClick={() => addDigit("1")}
            >
              <_Builtin.Block
                className={_utils.cx(_styles, "keypad")}
                tag="div"
              >
                <_Builtin.Block tag="div">{"1"}</_Builtin.Block>
              </_Builtin.Block>
            </_Builtin.Block>
            <_Builtin.Block
              className={_utils.cx(_styles, "keypadcontainer")}
              tag="div"
              onClick={() => addDigit("2")}
            >
              <_Builtin.Block
                className={_utils.cx(_styles, "keypad")}
                tag="div"
              >
                <_Builtin.Block tag="div">{"2"}</_Builtin.Block>
                <_Builtin.Block
                  className={_utils.cx(_styles, "keypad_subtext")}
                  tag="div"
                >
                  {"ABC"}
                </_Builtin.Block>
              </_Builtin.Block>
            </_Builtin.Block>
            <_Builtin.Block
              className={_utils.cx(_styles, "keypadcontainer")}
              tag="div"
              onClick={() => addDigit("3")}
            >
              <_Builtin.Block
                className={_utils.cx(_styles, "keypad")}
                tag="div"
              >
                <_Builtin.Block tag="div">{"3"}</_Builtin.Block>
                <_Builtin.Block
                  className={_utils.cx(_styles, "keypad_subtext")}
                  tag="div"
                >
                  {"DEF"}
                </_Builtin.Block>
              </_Builtin.Block>
            </_Builtin.Block>
            <_Builtin.Block
              className={_utils.cx(_styles, "keypadcontainer")}
              tag="div"
              onClick={() => addDigit("4")}
            >
              <_Builtin.Block
                className={_utils.cx(_styles, "keypad")}
                tag="div"
              >
                <_Builtin.Block tag="div">{"4"}</_Builtin.Block>
                <_Builtin.Block
                  className={_utils.cx(_styles, "keypad_subtext")}
                  tag="div"
                >
                  {"GHI"}
                </_Builtin.Block>
              </_Builtin.Block>
            </_Builtin.Block>
            <_Builtin.Block
              className={_utils.cx(_styles, "keypadcontainer")}
              tag="div"
              onClick={() => addDigit("5")}
            >
              <_Builtin.Block
                className={_utils.cx(_styles, "keypad")}
                tag="div"
              >
                <_Builtin.Block tag="div">{"5"}</_Builtin.Block>
                <_Builtin.Block
                  className={_utils.cx(_styles, "keypad_subtext")}
                  tag="div"
                >
                  {"JKL"}
                </_Builtin.Block>
              </_Builtin.Block>
            </_Builtin.Block>
            <_Builtin.Block
              className={_utils.cx(_styles, "keypadcontainer")}
              tag="div"
              onClick={() => addDigit("6")}
            >
              <_Builtin.Block
                className={_utils.cx(_styles, "keypad")}
                tag="div"
              >
                <_Builtin.Block tag="div">{"6"}</_Builtin.Block>
                <_Builtin.Block
                  className={_utils.cx(_styles, "keypad_subtext")}
                  tag="div"
                >
                  {"MNO"}
                </_Builtin.Block>
              </_Builtin.Block>
            </_Builtin.Block>
            <_Builtin.Block
              className={_utils.cx(_styles, "keypadcontainer")}
              tag="div"
              onClick={() => addDigit("7")}
            >
              <_Builtin.Block
                className={_utils.cx(_styles, "keypad")}
                tag="div"
              >
                <_Builtin.Block tag="div">{"7"}</_Builtin.Block>
                <_Builtin.Block
                  className={_utils.cx(_styles, "keypad_subtext")}
                  tag="div"
                >
                  {"PQRS"}
                </_Builtin.Block>
              </_Builtin.Block>
            </_Builtin.Block>
            <_Builtin.Block
              className={_utils.cx(_styles, "keypadcontainer")}
              tag="div"
              onClick={() => addDigit("8")}
            >
              <_Builtin.Block
                className={_utils.cx(_styles, "keypad")}
                tag="div"
              >
                <_Builtin.Block tag="div">{"8"}</_Builtin.Block>
                <_Builtin.Block
                  className={_utils.cx(_styles, "keypad_subtext")}
                  tag="div"
                >
                  {"TUV"}
                </_Builtin.Block>
              </_Builtin.Block>
            </_Builtin.Block>
            <_Builtin.Block
              className={_utils.cx(_styles, "keypadcontainer")}
              tag="div"
              onClick={() => addDigit("9")}
            >
              <_Builtin.Block
                className={_utils.cx(_styles, "keypad")}
                tag="div"
              >
                <_Builtin.Block tag="div">{"9"}</_Builtin.Block>
                <_Builtin.Block
                  className={_utils.cx(_styles, "keypad_subtext")}
                  tag="div"
                >
                  {"WXYZ"}
                </_Builtin.Block>
              </_Builtin.Block>
            </_Builtin.Block>
            <_Builtin.Block
              className={_utils.cx(_styles, "keypadcontainer")}
              tag="div"
            >
              <_Builtin.Block
                className={_utils.cx(_styles, "keypad")}
                tag="div"
                onClick={() => addDigit("*")}
              >
                <_Builtin.Block tag="div">{"*"}</_Builtin.Block>
              </_Builtin.Block>
            </_Builtin.Block>
            <_Builtin.Block
              className={_utils.cx(_styles, "keypadcontainer")}
              tag="div"
              onClick={() => addDigit("0")}
            >
              <_Builtin.Block
                className={_utils.cx(_styles, "keypad")}
                tag="div"
              >
                <_Builtin.Block tag="div">{"0"}</_Builtin.Block>
                <_Builtin.Block
                  className={_utils.cx(_styles, "keypad_subtext")}
                  tag="div"
                >
                  {"+"}
                </_Builtin.Block>
              </_Builtin.Block>
            </_Builtin.Block>
            <_Builtin.Block
              className={_utils.cx(_styles, "keypadcontainer")}
              tag="div"
              onClick={() => addDigit("#")}
            >
              <_Builtin.Block
                className={_utils.cx(_styles, "keypad")}
                tag="div"
              >
                <_Builtin.Block tag="div">{"#"}</_Builtin.Block>
              </_Builtin.Block>
            </_Builtin.Block>
            <_Builtin.Block
              className={_utils.cx(_styles, "keypadcontainer")}
              tag="div"
            />
            <_Builtin.Block
              className={_utils.cx(_styles, "keypadcontainer")}
              tag="div"
            >
              <_Builtin.Link
                className={_utils.cx(_styles, "icon_call")}
                // data-w-id="d105f99f-87d8-00b1-ab20-2f34de1ff959"
                button={false}
                block="inline"
                options={{
                  href: "#",
                }}
                onClick={() => dialerHandler(currentNumber)}
              >
                <_Builtin.Image
                  width="auto"
                  height="auto"
                  loading="lazy"
                  alt=""
                  src="images/654dfac59c99624500d8adf9_home_icon_03-white.svg"
                />
              </_Builtin.Link>
            </_Builtin.Block>
            <_Builtin.Block
              className={_utils.cx(_styles, "keypadcontainer")}
              tag="div"
              onClick={erase}
            >
              <_Builtin.Block
                className={_utils.cx(_styles, "icon_dialer")}
                tag="div"
              >
                <_Builtin.Image
                  width="auto"
                  height="auto"
                  loading="lazy"
                  alt=""
                  src="images/66968578d5889c78730e31a1_dialer_03.svg"
                />
              </_Builtin.Block>
            </_Builtin.Block>
          </_Builtin.Block>
        </_Builtin.Block>
      </div>
      {dialerLoading ? "" : <div className={"phone_oncall"} tag="div" style={{ display: callStatus === STATUS.ONCALL && "flex" }}>
        <_Builtin.Block
          className={_utils.cx(_styles, "phone_oncall-top")}
          tag="div"
        >
          <_Builtin.Block
            className={_utils.cx(_styles, "phonehome_top")}
            tag="div"
          >
            <_Builtin.Block
              className={_utils.cx(_styles, "phonehome_avatar")}
              tag="div"
            >
              <_Builtin.Image
                className={_utils.cx(_styles, "avatar_image", "_w-100")}
                width="auto"
                height="auto"
                loading="lazy"
                alt=""
                src="images/66968578d5889c78730e31f3_avatar_01.png"
              />
            </_Builtin.Block>
            <_Builtin.Block
              className={_utils.cx(_styles, "phonehometop_details")}
              tag="div"
            >
              <_Builtin.Heading
                className={_utils.cx(_styles, "callheader")}
                tag="h1"
              >
                {incomingCallInfo.callFrom}
              </_Builtin.Heading>
              <_Builtin.Block
                className={_utils.cx(_styles, "p-style1")}
                tag="div"
              >
                {"00:06"}
              </_Builtin.Block>
            </_Builtin.Block>
          </_Builtin.Block>
          <_Builtin.Block
            className={_utils.cx(_styles, "oncall_controls")}
            tag="div"
          >
            <_Builtin.Block
              className={_utils.cx(_styles, "oncallbtn_col")}
              tag="div"
            >
              <_Builtin.Link
                className={_utils.cx(_styles, "phonehome_btn", "margin-0")}
                button={false}
                block="inline"
                options={{
                  href: "#",
                }}
              >
                <_Builtin.Block
                  className={_utils.cx(_styles, "phonehome_btn_icon")}
                  tag="div"
                >
                  <_Builtin.Image
                    width="auto"
                    height="auto"
                    loading="lazy"
                    alt=""
                    src="images/66968578d5889c78730e31c7_oncall_01.svg"
                  />
                </_Builtin.Block>
                <_Builtin.Block tag="div">{"Mute"}</_Builtin.Block>
              </_Builtin.Link>
            </_Builtin.Block>
            <_Builtin.Block
              className={_utils.cx(_styles, "oncallbtn_col")}
              tag="div"
            >
              <_Builtin.Link
                className={_utils.cx(_styles, "phonehome_btn", "margin-0")}
                button={false}
                block="inline"
                options={{
                  href: "#",
                }}
                onClick={openModalKeypad}
              >
                <_Builtin.Block
                  className={_utils.cx(_styles, "phonehome_btn_icon")}
                  tag="div"
                >
                  <_Builtin.Image
                    width="auto"
                    height="auto"
                    loading="lazy"
                    alt=""
                    src="images/66968578d5889c78730e31a9_oncall_02.svg"
                  />
                </_Builtin.Block>
                <_Builtin.Block tag="div">{"Keypad"}</_Builtin.Block>
              </_Builtin.Link>
            </_Builtin.Block>
            <_Builtin.Block
              className={_utils.cx(_styles, "oncallbtn_col")}
              tag="div"
            >
              <_Builtin.Link
                className={_utils.cx(_styles, "phonehome_btn", "margin-0")}
                button={false}
                block="inline"
                options={{
                  href: "#",
                }}
              >
                <_Builtin.Block
                  className={_utils.cx(_styles, "phonehome_btn_icon")}
                  tag="div"
                >
                  <_Builtin.Image
                    width="auto"
                    height="auto"
                    loading="lazy"
                    alt=""
                    src="images/66968578d5889c78730e31a7_oncall_03.svg"
                  />
                </_Builtin.Block>
                <_Builtin.Block tag="div">{"Speaker"}</_Builtin.Block>
              </_Builtin.Link>
            </_Builtin.Block>
            <_Builtin.Block
              className={_utils.cx(_styles, "oncallbtn_col")}
              tag="div"
            >
              <_Builtin.Link
                className={_utils.cx(_styles, "phonehome_btn", "margin-0")}
                data-w-id="d105f99f-87d8-00b1-ab20-2f34de1ff97c"
                button={false}
                block="inline"
                options={{
                  href: "#",
                }}
                onClick={handleHangUp}
              >
                <_Builtin.Block
                  className={_utils.cx(_styles, "phonehome_btn_icon", "end")}
                  tag="div"
                >
                  <_Builtin.Image
                    width="auto"
                    height="auto"
                    loading="lazy"
                    alt=""
                    src="images/66968578d5889c78730e31d6_oncall_05.svg"
                  />
                </_Builtin.Block>
                <_Builtin.Block tag="div">{"End Call"}</_Builtin.Block>
              </_Builtin.Link>
            </_Builtin.Block>
            <_Builtin.Block
              className={_utils.cx(_styles, "oncallbtn_col")}
              tag="div"
            >
              {/* <_Builtin.Link
                className={_utils.cx(_styles, "phonehome_btn", "margin-0")}
                button={false}
                block="inline"
                options={{
                  href: "#",
                }}
              >
                <_Builtin.Block
                  className={_utils.cx(_styles, "phonehome_btn_icon")}
                  tag="div"
                >
                  <_Builtin.Image
                    width="auto"
                    height="auto"
                    loading="lazy"
                    alt=""
                    src="images/66968578d5889c78730e31a3_oncall_04.svg"
                  />
                </_Builtin.Block>
                <_Builtin.Block tag="div">{"Hold"}</_Builtin.Block>
              </_Builtin.Link> */}
              <_Builtin.Block
                className={_utils.cx(_styles, "oncallbtn_col")}
                tag="div"
              >
                <_Builtin.Link
                  className={_utils.cx(_styles, "phonehome_btn", "margin-0")}
                  button={false}
                  block="inline"
                  options={{
                    href: "#",
                  }}
                  onClick={() => dialerHandler(currentNumber, true)}
                >
                  <_Builtin.Block
                    className={_utils.cx(_styles, "phonehome_btn_icon")}
                    tag="div"
                  >
                    <_Builtin.Image
                      width="auto"
                      height="auto"
                      loading="lazy"
                      alt=""
                      src="/images/dropcall.png"
                    />
                  </_Builtin.Block>
                  <_Builtin.Block tag="div">{"Voicemail Drop"}</_Builtin.Block>
                </_Builtin.Link>
              </_Builtin.Block>
            </_Builtin.Block>
          </_Builtin.Block>
        </_Builtin.Block>
      </div>}
    </div>
  );
}
